import { FC, Fragment } from 'react';

import { EMAIL } from 'utils/constants/contacts';

import Column, { ColumnsRow, ColumnsWrapper } from 'bloko/blocks/column';
import Gap from 'bloko/blocks/gap';
import { H1Section } from 'bloko/blocks/header';
import Link from 'bloko/blocks/link';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import { Header } from 'components/Header/Header';

const AppError: FC = () => {
    const trl = useTrls();

    return (
        <Fragment>
            <Header />
            <ColumnsWrapper>
                <ColumnsRow>
                    <Column xs="4" s="8" m="12" l="16">
                        <Gap top bottom>
                            <H1Section>{trl('appError.title')}</H1Section>
                            <VSpacing base={8} />
                            <p>{trl('appError.part1')}</p>
                            <VSpacing base={8} />
                            <p>
                                {trl('appError.part2')}
                                <Link href={`mailto:${EMAIL}?subject=${trl('appError.title')}`}>{EMAIL}</Link>
                            </p>
                        </Gap>
                    </Column>
                </ColumnsRow>
            </ColumnsWrapper>
        </Fragment>
    );
};

export default AppError;
